import { h } from 'preact';

const Backdrop = ({ isOpen, handleCloseEvent }) => (
  <div
    className={`w-full h-full fixed  left-0 top-0 " ${
      isOpen
        ? 'opacity-100 z-10 bg-black/60 backdrop-blur-md'
        : 'opacity-0 -z-1'
    }`}
    onClick={() => handleCloseEvent()}
  />
);

export default Backdrop;
